import React from 'react';
import { observer } from '../../shared/observer';
import { runBusy, isBusy } from '../../shared/busy';

class InviteFriendView extends React.Component {
  // copied: 'link' | 'message' | null — какая кнопка показывает «Скопировано».
  state = { copied: null, busy: {} };

  componentWillUnmount() { clearTimeout(this._copiedTimer); }

  setLinkInput = (n) => { this._linkInput = n; };

  _flashCopied = (kind) => {
    this.setState({ copied: kind });
    clearTimeout(this._copiedTimer);
    this._copiedTimer = setTimeout(() => this.setState({ copied: null }), 2000);
  };

  copy = (text) => async () => {
    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text);
        this._flashCopied('link');
        return;
      } catch (e) { /* clipboard недоступен — падаем на ручное выделение */ }
    }
    // Fallback: выделяем ссылку в поле, чтобы можно было скопировать вручную.
    if (this._linkInput) { this._linkInput.focus(); this._linkInput.select(); }
  };

  share = (text) => () => {
    if (isBusy(this, 'share')) return;
    if (navigator.share) {
      runBusy(this, 'share', async () => {
        try { await navigator.share({ text }); } catch (e) { /* user cancel */ }
      });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
        .then(() => this._flashCopied('message'))
        .catch(() => { /* noop */ });
    } else if (this._linkInput) {
      this._linkInput.focus();
      this._linkInput.select();
    }
  };

  render() {
    const ci = this.props.auth.clientInfo || {};
    const ref = ci.referal_info || {};
    if (!ref.code) {
      return <div><h1>Пригласить друга</h1><p>Реферальная программа недоступна.</p></div>;
    }
    return (
      <div>
        <h1>Пригласить друга</h1>
        {/* inviter_bonus=false — клиенту бонус за друга не начислится (#264) */}
        <p className="ng-checkout__hint">
          {ref.inviter_bonus === false
            ? 'Поделитесь промокодом — друг получит бонус.'
            : 'Поделитесь промокодом — друг получит бонус, а вы получите бонус, когда он оформит заказ.'}
        </p>

        <div className="ng-bonus-card">
          <div className="ng-bonus-card__label">Ваш промокод</div>
          <div className="ng-bonus-card__value">{ref.code}</div>
        </div>

        {ref.link && (
          <div className="ng-invite-link">
            <input ref={this.setLinkInput} type="text" className="input__text" readOnly value={ref.link} onFocus={(e) => e.target.select()} />
            <button type="button" className="btn btn--ghost btn--mini" onClick={this.copy(ref.link)}>
              {this.state.copied === 'link' ? 'Скопировано' : 'Копировать'}
            </button>
          </div>
        )}

        {ref.qr_link && (
          <div className="ng-invite-qr">
            <img className="ng-img" src={`https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodeURIComponent(ref.qr_link)}`} alt="QR" />
          </div>
        )}

        {ref.message && (
          <button type="button" className="btn btn--block" disabled={isBusy(this, 'share')} onClick={this.share(ref.message)}>
            {this.state.copied === 'message' ? 'Скопировано' : 'Поделиться'}
          </button>
        )}

        {ref.referals_count > 0 && (
          <p className="ng-checkout__hint">Друзей по вашей ссылке: <strong>{ref.referals_count}</strong></p>
        )}
      </div>
    );
  }
}

export const InviteFriend = observer(InviteFriendView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/InviteFriend.jsx